import styled from 'styled-components';

type ButtonGroupAlign = 'LEFT' | 'CENTER' | 'RIGHT';
type ButtonGroupProps = {
  align?: ButtonGroupAlign;
}

const cssAlignForAlign = (align?: ButtonGroupAlign) => {
  if (align === 'CENTER') {
    return 'center';
  } if (align === 'RIGHT') {
    return 'end';
  }
  return 'start';
};

const ButtonGroup = styled.div <ButtonGroupProps>`
  display: flex;
  justify-content: ${(p) => cssAlignForAlign(p.align)};
  align-items: center;

  > button,
  > a {
    margin-right: 10px;
  }

  > button:last-child,
  > a:last-child {
    margin-right: 0;
  }
`;

export default ButtonGroup;
